<!-- 家长监护-底部下载 -->
<template>
  <div class="download">
      <div class="item">
          <div class="item_top">
              <p>服务方式</p>
          </div>
          <div class="item_content">
              <div class="item_conn">
                <img src="https://cdn.welove520.com/static/res/vue/playbay/telephone.png">
                <span>电话：010-82609308</span>
              </div>

              <div class="item_conn">
                <img src="https://cdn.welove520.com/static/res/vue/playbay/fax.png">
                <span>电话：010-82609308</span>
              </div>
          </div>
      </div>

      <div class="item">
          <div class="item_top">
              <p>服务申请书下载</p>
          </div>
          <div class="item_content">
              <div class="item_conn download_file">
                <img src="https://cdn.welove520.com/static/res/vue/playbay/file.png">
                <span>附件1：</span>
                <a href="https://cdn.welove520.com/static/res/vue/doc/%E7%9B%91%E6%8A%A4%E4%BA%BA%E4%BF%A1%E6%81%AF%E8%A1%A8.doc">监护人信息表</a>
              </div>

              <div class="item_conn download_file">
                <img src="https://cdn.welove520.com/static/res/vue/playbay/file.png">
                <span>附件2：</span>
                <a href="https://cdn.welove520.com/static/res/vue/doc/%E8%A2%AB%E7%9B%91%E6%8A%A4%E4%BA%BA%E4%BF%A1%E6%81%AF%E8%A1%A8.doc">被监护人信息表</a>
              </div>

              <div class="item_conn download_file">
                <img src="https://cdn.welove520.com/static/res/vue/playbay/file.png">
                <span>附件3：</span>
                <a href="https://cdn.welove520.com/static/res/vue/doc/%E7%BD%91%E7%BB%9C%E6%B8%B8%E6%88%8F%E6%9C%AA%E6%88%90%E5%B9%B4%E4%BA%BA%E5%AE%B6%E9%95%BF%E7%9B%91%E6%8A%A4%E7%94%B3%E8%AF%B7%E4%B9%A6.doc">网络游戏未成年人家长监护申请书</a>
              </div>
          </div>
      </div>

      <div class="item">
          <div class="item_top">
              <p>家长监护服务FAQ</p>
          </div>
          <div class="item_faq">
              <div class="item_faq_q1">
                  <span class="item_q">Q1：</span>
                <span class="item_q">“网络游戏未成年人家长监护机制工程”</span>
              </div>
              <span class="item_a">网络游戏未成年人家长监护工程”是一项由网页游戏平台根据国家有关规定而发起的一个项目……</span>
              <span class="item_q">Q2：什么情况下需要申请该项服务呢？</span>
              <span class="item_a">在监护人发现被监护人有沉溺网络游戏的情况下，监护人可向公司申请发起未成年人家长监护机制。</span>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.download {
  margin-top: 50px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 1000px;
}

.item {
  width: 300px;
  height: 280px;
  border-radius: 10px;
  border: 1px solid #cececf;
}

.item_top {
  height: 50px;
  background: #f95072;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 0 0 10px;
}

.item_top > p {
  font-size: 20px;
  color: white;
  text-align: justify;
}

.item_content {
  width: 300px;
  height: 230px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.item_conn {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
}

.item_conn > img {
  width: 20px;
}

.item_conn > span {
  font-size: 18px;
  color: #303032;
  text-align: justify;
  margin-left: 10px;
}

.item_conn > a {
  max-width: 130px;
}

.item_conn:nth-child(2) {
  margin-top: 25px;
  margin-bottom: 25px;
}

.download_file {
  width: 230px;
  align-items: flex-start;
  justify-content: flex-start;
}

.download_file > a {
  text-decoration: none;
}

.item_faq {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 0 10px;
}

.item_faq_q1 {
  margin-top: 15px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}

.item_q {
  font-size: 16px;
  color: #f95072;
}

.item_a {
  font-size: 14px;
  color: #303032;
}

.item_faq > span:nth-child(3) {
    margin-top: 15px; 
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue